angular.module('app').factory('ScriptInjectionService', function () {
    let fac = {
        isInjectedScript: isInjectedScript,
        escapeHtml: escapeHtml
    };
    function isInjectedScript(inputString) {
        if (inputString !== null && !angular.isUndefined(inputString)) {
            let injectionArray = ['<', '>', ';', '{', '}'];
            let arrayLength = injectionArray.length;
            for (let index = 0; index < arrayLength; index++) {
                if (inputString.indexOf(injectionArray[index]) > -1) {
                    return true;
                }
            }
        }
        return false;
    }
    function escapeHtml(unsafe) {
        return unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }
    return fac;
});
